// Archivo para el botón de actualizar
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Icon from '@mui/icons-material/Edit';

const UpdateButton = ({ entityType, onClick, loading, disabled, itemId }) => {
    const { t } = useTranslation();

    const buttonText = loading
        ? t('buttons.updating')
        : t(`buttons.update${entityType.charAt(0).toUpperCase() + entityType.slice(1)}`);

    return (
        <button
            className={`button update-button ${entityType}-update-button`}
            onClick={() => onClick(itemId)}
            disabled={disabled || loading}
            aria-label={buttonText}
        >
            <Icon fontSize="small" />
            {!loading && <span>{buttonText}</span>}
            {loading && <span className="button-spinner" />}
        </button>
    );
};

UpdateButton.propTypes = {
    entityType: PropTypes.oneOf(['user', 'client', 'product', 'activity', 'task']).isRequired,
    onClick: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

UpdateButton.defaultProps = {
    loading: false,
    disabled: false
};

export default UpdateButton;